"use client";

import { useTheme } from "styled-components";
import { getColor, getThemeColor } from "../../utils";
import { useMemo } from "react";

export function useThemeColor(colorName: string, def: string = null): string {
  const theme = useTheme();
  const color = useMemo(() => {
    if (!colorName || colorName === "clear") return getColor("white");
    return getThemeColor(colorName, theme, def);
  }, [colorName, def, theme]);

  return color;
}
